import { render, staticRenderFns } from "./AdminBuildingStockForm.vue?vue&type=template&id=75d0cbc9&"
import script from "./AdminBuildingStockForm.vue?vue&type=script&lang=js&"
export * from "./AdminBuildingStockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports